import { dynamicDocInstance } from '@/api/dynamic/dynamic-document-instance';
import { AltitudeMark } from '@/types/dynamicDoc';

/** Отметка высоты */
export const altitudeMark = {
    getAltitudeMarkByWorkTypeIdRange: (data: string[]): Promise<AltitudeMark[]> =>
        dynamicDocInstance.post<AltitudeMark[]>('Work/GetAltitudeMarkByWorkTypeIdRange', data).then(x => x.data),
};
